export enum PageTitle {
  AddAddressBookEntry = 'AddAddressBookEntry',
  AddAppointment = 'AddAppointment',
  AddCallLog = 'AddCallLog',
  AddCase = 'AddCase',
  AddLead = 'AddLead',
  AddNote = 'AddNote',
  AddOpportunity = 'AddOpportunity',
  AddTask = 'AddTask',
  CalendarCompose = 'CalendarCompose',
  CalendarRead = 'CalendarRead',
  EditAddressBookEntry = 'EditAddressBookEntry',
  EditLead = 'EditLead',
  EntryPage = 'EntryPage',
  IqBoost = 'IqBoost',
  MailCompose = 'MailCompose',
  MailRead = 'MailRead',
  Preferences = 'Preferences',
  RelatedDetailOpportunitiesAndCases = 'RelatedDetailOpportunitiesAndCases',
  RelatedOpportunitiesAndCases = 'RelatedOpportunitiesAndCases',
  SyncConfiguration = 'Maximizer - Sync Configuration',
}
